import { Card, CardContent } from "@patient-watch/ui/card";
import { useMemo } from "react";
import VisaQ8Base from "../visa/VisaQ8Base";
import { parseBranchingScaleOptions } from "./parseBranchingScaleOptions";

interface BranchingScaleOptionsInputData {
    input_id?: string;
    input_label: string | null;
    scale_options: unknown;
    is_optional: boolean | null;
}

interface BranchingScaleOptionsInputProps {
    input: BranchingScaleOptionsInputData;
    name?: string;
}

export function BranchingScaleOptionsInput({ input, name }: BranchingScaleOptionsInputProps) {
    const branches = useMemo(() => parseBranchingScaleOptions(input.scale_options), [input.scale_options]);
    const fieldName = name ?? input.input_id ?? "branching-scale-options";

    if (branches.length === 0) {
        return (
            <Card>
                <CardContent className="p-4 text-destructive text-lg">
                    This question has no valid response options configured.
                </CardContent>
            </Card>
        );
    }

    const scaleLabelsMap = Object.fromEntries(
        branches.map((branch) => [branch.value, branch.options.map((option) => option.label)])
    );
    const pointsMap = Object.fromEntries(
        branches.map((branch) => [branch.value, branch.options.map((option) => option.value)])
    );

    return (
        <VisaQ8Base
            name={fieldName}
            required={!input.is_optional}
            questionLabel={input.input_label ?? ""}
            branches={branches}
            scaleLabelsMap={scaleLabelsMap}
            pointsMap={pointsMap}
            durationPrompt={branches[0]?.durationPrompt ?? ""}
        />
    );
}
